import React from 'react';
import { Box, Typography, styled, Card, CardContent } from '@mui/material';

const ContentWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

const PageTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.875rem',
  fontWeight: 700,
  color: theme.palette.text.primary,
}));

const PlaceholderCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  boxShadow: 'none',
}));

export const AdminPage: React.FC = () => {
  return (
    <ContentWrapper>
      <PageTitle>Admin</PageTitle>
      <PlaceholderCard>
        <CardContent>
          <Typography variant="body1" color="text.secondary">
            Admin panel coming soon...
          </Typography>
        </CardContent>
      </PlaceholderCard>
    </ContentWrapper>
  );
};


